import { Dayjs } from 'dayjs'
import { KeyboardEvent } from 'react'

const basicOperator = [
  'ArrowLeft',
  'ArrowUp',
  'ArrowDown',
  'ArrowRight',
  'Backspace',
  'Delete',
  'Tab',
]
const allowedNumber = [
  ...basicOperator,
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
]

export const handleKeyDownNumberOnly = (e: KeyboardEvent<HTMLInputElement>) => {
  const isOnMeta = e.metaKey || e.ctrlKey
  const isPaste = isOnMeta && e.key === 'v'
  const isCopy = isOnMeta && e.key === 'c'

  if (!allowedNumber.includes(e.key) && !isPaste && !isCopy) {
    e.preventDefault()
  }
}

export const handleKeyDownNotAllowSpace = (
  e: KeyboardEvent<HTMLInputElement>,
) => {
  if (e.key === ' ') {
    e.preventDefault()
  }
}

export const checkPasswordStrong = (_: unknown, pass: string) => {
  const isEightChars = pass?.length >= 8 || false
  const isContainNumber = /\d/.test(pass)
  const isContainAlpha = /[a-zA-Z]/g.test(pass)
  if (isEightChars && isContainNumber && isContainAlpha) {
    return Promise.resolve()
  }
  return Promise.reject(new Error('Please using strong password'))
}

export const inputNumberParser = (val: string | undefined) => {
  if (val === '') return ''
  if (val === undefined) return ''
  const formated = val.replace(/[^0-9]/g, '')
  if (Number(formated) || Number(formated) === 0) return Number(formated)
  return ''
}

export const numberOnlyCannotStartFromZero = (value: string) => {
  return value.replace(/^[^1-9][^0-9]*/g, '')
}

export function formatMoneyRMG(
  amount: number | string | undefined,
  currency = '',
) {
  if (!amount && amount !== 0) return amount
  const symbol = currency
  const numberString = amount !== null ? amount.toString() : '0'
  const split = numberString.split('.')
  let decimal = split[1]
  const formatted = split[0].replace(/(\d)(?=(\d{3})+$)/g, '$&.')

  if (decimal === undefined) {
    decimal = '00'
  } else if (decimal[1] === undefined) {
    decimal = `${decimal}`
  }
  return `${symbol ? `${symbol} ` : ''}${formatted}${
    decimal !== '00' ? `,${decimal}` : ''
  }`
}

export const matchPassword = (password: string, confirm: string) => {
  if (!password || !confirm || password === confirm) {
    return Promise.resolve()
  }
  return Promise.reject(new Error('Password not match'))
}

export const validatorConfirm = (_: unknown, val: string) => {
  if (val === 'CONFIRM') {
    return Promise.resolve()
  }
  return Promise.reject(new Error('Please type "CONFIRM"'))
}

export const validatorInputRange = (range: Dayjs[]) => {
  if (range?.length > 1) {
    return Promise.resolve()
  }
  return Promise.reject(new Error('Please select the range'))
}

export const validatorCheckbox = (value: string[], min: number) => {
  if (value?.length >= min) {
    return Promise.resolve()
  }
  return Promise.reject(new Error('Please select option'))
}

export const validatorMinNumber =
  (min: number) => (_: unknown, num: number) => {
    if (num === null || num === undefined) return Promise.resolve()
    if (num >= min) {
      return Promise.resolve()
    }
    return Promise.reject(
      new Error(`Number of sessions must be ${min} or higher!`),
    )
  }

export const numberOnly = (value: string) => {
  return value.replace(/[^0-9]/g, '')
}
